import { render, staticRenderFns } from "./code.vue?vue&type=template&id=46cd5b3e"
import script from "./code.vue?vue&type=script&lang=js"
export * from "./code.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports